import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({
  destinations: [],
  packages: [],
  visas: [],
  groupTours: [],
  tripTypes: [],
  loading: true,
  error: null,
  reload: () => {},
});

export function ContentProvider({ children }) {
  const [state, setState] = useState({
    destinations: [], packages: [], visas: [], groupTours: [], tripTypes: [],
    loading: true, error: null,
  });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const res = await axios.get(`${API}/content`);
      const d = res.data;
      setState({
        destinations: d.destinations || [],
        packages: d.packages || [],
        visas: d.visas || [],
        groupTours: d.group_tours || [],
        testimonials: d.testimonials || [],
        offers: d.offers || [],
        tripTypes: d.trip_types || [],
        loading: false, error: null,
      });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: "Could not load holiday content. Please check your connection and try again." }));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ ...state, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);

export const getDestination = (destinations, slug) => destinations.find((d) => d.slug === slug);
export const getPackage = (packages, slug) => packages.find((p) => p.slug === slug);

export function searchContent({ destinations, packages, visas }, q) {
  const needle = (q || "").trim().toLowerCase();
  if (!needle) return { packages: [], destinations: [], visas: [] };
  const hit = (s) => (s || "").toLowerCase().includes(needle);
  return {
    packages: packages.filter((p) =>
      hit(p.title) || hit(p.destination) || hit(p.region) ||
      (p.holiday_types || []).some(hit) || (p.travel_styles || []).some(hit) ||
      (p.highlights || []).some(hit)),
    destinations: destinations.filter((d) =>
      hit(d.name) || hit(d.country) || hit(d.tagline) || hit(d.region)),
    visas: visas.filter((v) => hit(v.country) || hit(v.slug)),
  };
}
